var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.removed
    ? _c(
        "div",
        { staticClass: "file-upload-gallery-item" },
        [
          _c("vuestic-file-upload-undo", {
            staticClass: "file-upload-gallery-item-undo",
            on: { recover: _vm.recoverImage },
          }),
        ],
        1
      )
    : _c(
        "div",
        {
          staticClass: "file-upload-gallery-item",
          class: _vm.notGalleryItemClass,
        },
        [
          _c("img", {
            staticClass: "file-upload-gallery-item-image",
            attrs: { src: _vm.previewImage, alt: "" },
          }),
          _c("div", { staticClass: "file-upload-gallery-item-overlay" }, [
            _c(
              "div",
              {
                staticClass: "file-upload-gallery-item-name",
                attrs: { title: _vm.file.name },
              },
              [_vm._v("\n      " + _vm._s(_vm.file.name) + "\n    ")]
            ),
            _c("div", { staticClass: "file-upload-gallery-item-size" }, [
              _vm._v("\n      " + _vm._s(_vm.file.size) + "\n    "),
            ]),
            _c(
              "button",
              {
                staticClass:
                  "btn-text btn-text--secondary file-upload-gallery-item-button",
                attrs: { type: "button" },
                on: { click: _vm.removeImage },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("fileUpload.deleteFile")) +
                    "\n    "
                ),
              ]
            ),
          ]),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }